import { RouteType } from "./config";
import RoleMaster from "../pages/UserManagementMaster/RoleMaster/RoleMaster";
import UserPermissionMaster from "../pages/UserManagementMaster/UserPermissionMaster/UserPermissionMaster";
import HomePage from "../pages/home/HomePage";
import LoginPage from "../loginPage/LoginPage";
import HomeIcon from "@mui/icons-material/Home";
import DashboardPageLayout from "../pages/master/MasterPageLayout";
import DashboardIndex from "../pages/master/MasterPageIndex";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ZoneMaster from "../pages/master/ZoneMaster/ZoneMaster";
import StateMaster from "../pages/master/StateMaster/StateMaster";
import CountryMaster from "../pages/master/CountryMaster/CountryMaster";
import CityMaster from "../pages/master/CityMaster/CityMaster";
import Taxmaster from '../pages/master/Taxmaster/Taxmaster';
import Unitmaster from "../pages/master/Unitmaster/Unitmaster";
import MaterialRecieptNoteMaster from "../pages/Inventory/MaterialRecieptNote/MaterialRecieptNoteMaster";
import CreateMaterialRecieptNote from "../pages/Inventory/MaterialRecieptNote/CreateMaterialRecieptNote";
import EditMaterialRecieptNote from "../pages/Inventory/MaterialRecieptNote/EditMaterialRecieptNote";



import Emailsettingmaster from "../pages/Emailsystem/Emailsetting/Emailsettingmaster";
import EmailcampgianMaster from "../pages/Emailsystem/Emailcampagian/Emailcampagianmaster";
import CreatemailcampgiontForm from "../pages/Emailsystem/Emailcampagian/Createcampgainform";
import Editcampgianmailmaster from "../pages/Emailsystem/Emailcampagian/Editcampagianmaster";
import EmaileventMaster from "../pages/Emailsystem/EmailEventSettings/EmaileventMaster";
import CreatemaileventForm from "../pages/Emailsystem/EmailEventSettings/CreatemaileventForm";
import Editeventemail from "../pages/Emailsystem/EmailEventSettings/Editeventemail";
import CampaignTemplate from "../pages/Emailsystem/CampaignTemplate/CampaignTemplate";
import AddCampaignTemplate from "../pages/Emailsystem/CampaignTemplate/AddCampaignTemplate";
import EditCampaignTemplate from "../pages/Emailsystem/CampaignTemplate/EditCampaignTemplate";
import Editgroupmaster from "../pages/Emailsystem/Group/Editgroupmaster";
import Creategroupmaster from "../pages/Emailsystem/Group/Creategroupmaster";
import Groupmaster from "../pages/Emailsystem/Group/Groupmaster";
import Login_Page from "../loginPage/Login_Page";
import Login_Page1 from "../loginPage/Login_Page1";
import Itemcategory from "../pages/master/Itemcategory/Itemcategory";
import BinKudaghar from "../pages/master/BinKudaghar/BinKudaghar";
import VehicleDetail from "../pages/master/VehicleDetail/VehicleDetail";
import BrandMaster from "../pages/master/BrandMaster/BrandMaster";
import FuelType from "../pages/master/FuelType/FuelType";
import FuelTypeAdd from "../pages/master/FuelType/FuelTypeAdd";
import FuelTypeEdit from "../pages/master/FuelType/FuelTypeEdit";
import BrandMasterAdd from "../pages/master/BrandMaster/BrandMasterAdd";
import BrandMasterEdit from "../pages/master/BrandMaster/BrandMasterEdit";
import VehicleDetailAdd from "../pages/master/VehicleDetail/VehicleDetailAdd";
import VehicleDetailEdit from "../pages/master/VehicleDetail/VehicleDetailEdit";
import VehicleType from "../pages/master/VehicleType/VehicleType";
import VehicleTypeAdd from "../pages/master/VehicleType/VehicleTypeAdd";
import VehicleTypeEdit from "../pages/master/VehicleType/VehicleTypeEdit";
import VehicleAudit from "../pages/master/VehicleAudit/VehicleAudit";
import VehicleAuditAdd from "../pages/master/VehicleAudit/VehicleAuditAdd";
import VehicleAuditEdit from "../pages/master/VehicleAudit/VehicleAuditEdit";
import VehicleTypeInfo from "../pages/master/VehicleTypeInfo/VehicleTypeInfo";
import VehicleTypeInfoAdd from "../pages/master/VehicleTypeInfo/VehicleTypeInfoAdd";
import VehicleTypeInfoEdit from "../pages/master/VehicleTypeInfo/VehicleTypeInfoEdit";
import FuelBalCorrection from "../pages/master/FuelBalCorrection/FuelBalCorrection";
import AreaWardMaster from "../pages/master/AreaWardMaster/AreaWardMaster";
import MenuMaster from "../pages/master/Menu/MenuMaster";
import MenuMasterAdd from "../pages/master/Menu/MenuMasterAdd";
import MenuMasterEdit from "../pages/master/Menu/MenuMasterEdit";
import Jurisdiction from "../pages/master/Jurisdiction/Jurisdiction";
import Empmaster from "../pages/Empinfo/Employee/Empmaster";
import EmployeeAdd from "../pages/Empinfo/Employee/Creatempform";
import Editempform from "../pages/Empinfo/Employee/Editempform";
import DepartmentMaster from "../pages/master/DepartmentMaster/DepartmentMaster";
import DesignationMaster from "../pages/master/DesignationMaster/DesignationMaster";
import Institute from "../pages/InstitueForm/Institute";
import InstituteAdd from "../pages/InstitueForm/InstituteAdd";
import InstituteEdit from "../pages/InstitueForm/InstituteEdit";
import HelpCreation from "../pages/HelpCreation/HelpCreation";
import HelpDesk from "../pages/HelpDesk/HelpDesk";
import FuelConspWithOpening from "../pages/Reports/FuelConspWithOpening/FuelConspWithOpening";
import FuelConspWithoughtOpening from "../pages/Reports/FuelConspWithoughtOpening/FuelConspWithoughtOpening";
import FuelConsumption from "../pages/Reports/FuelConsumed/FuelConsumption";
import ProbableWireTempering from "../pages/Reports/ProbableWireTempering/ProbableWireTempering";
import VehiclesDetailsSummery from "../pages/Reports/VehiclesDetailsSummery/VehiclesDetailsSummery";
import VehiclesNotMoved from "../pages/Reports/VehiclesNotMoved/VehiclesNotMoved";
import VehicleTrack from "../pages/Reports/VehicleTrack/VehicleTrack";
import BinKudagharAdd from "../pages/master/BinKudaghar/BinKudagharAdd";
import BinKudagharEdit from "../pages/master/BinKudaghar/BinKudagharEdit";
import TrackingReportData from "../pages/Reports/TrackingReportData/TrackingReportData";
import WardMaster from "../pages/master/WardMaster/WardMaster";
import PageNotFound from "../utils/PageNotFound";





const appRoutes: RouteType[] = [
  {
    index: true,
    element: <Login_Page />,
    state: "home",
  },
  {
    element: <HomePage />,
    state: "home",
    path: "/home",
    sidebarProps: {
      displayText: "Home",
      icon: <HomeIcon />,
    },
  },


  //======================Master Form End========================



  /////-------------------start ------Inventory-----------------------

  {
    path: "/storemanagement",
    element: <DashboardPageLayout />,
    state: "Inventory",

    sidebarProps: {
      displayText: "Inventory",
      icon: <DashboardOutlinedIcon />
    },

    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "Inventory.index",
      },


      {
        path: "/storemanagement/materialreceiptnote",
        element: <MaterialRecieptNoteMaster />,
        state: "Inventory.MRNForm",
        sidebarProps: {
          displayText: "Material Recpt Notes",
        }
      },
      {
        path: "/storemanagement/CreateMRN",
        element: <CreateMaterialRecieptNote />,
        state: "Inventory.CreateMRN",
      },
      {
        path: "/storemanagement/EditMRN",
        element: <EditMaterialRecieptNote />,
        state: "Inventory.EditMRN",
      },






    ]

  },

  //=================Aniket sahu Emailroute start ===================
  {
    path: "/communication",
    element: <DashboardPageLayout />,
    state: "communication",
    sidebarProps: {
      displayText: "emailsystem",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        path: "/communication/Group",
        element: <Groupmaster />,
        state: "emailsystem.Groupmaster",
        sidebarProps: {
          displayText: "Groupmaster",
        },
      },
      {

        path: "/communication/Creategroupmaster",
        element: <Creategroupmaster />,
        state: "communication.Creategroupmaster",
      },
      {
        path: "/communication/Editgroupmaster",
        element: <Editgroupmaster />,
        state: "communication.Editgroupmaster",

      },

      {
        path: "/communication/email/emailsettings",
        element: <Emailsettingmaster />,
        state: "email.emailMaster",
      },
      {
        path: "/communication/email/emailcampaign",
        element: <EmailcampgianMaster />,
        state: "email.emailMaster",
      },
      {
        path: "/communication/email/addcampagianmaster",
        element: <CreatemailcampgiontForm />,
        state: "email.emailMaster",
      },
      {
        path: "/communication/email/editcampagianmaster",
        element: <Editcampgianmailmaster />,
        state: "email.emailMaster",
      },
      {
        path: "/communication/email/emailevent",
        element: <EmaileventMaster />,
        state: "email.emailMaster",
      },
      {
        path: "/communication/email/addeventmaster",
        element: <CreatemaileventForm />,
        state: "email.emailMaster",
      },
      {
        path: "/communication/email/editeventnmaster",
        element: <Editeventemail />,
        state: "email.emailMaster",
      },

      {
        path: "/communication/template(sms/email)",
        element: <CampaignTemplate />,
        state: "emailsystem.CampaignTemplate",
        sidebarProps: {
          displayText: "CampaignTemplate",
        },
      },
      {

        path: "/communication/AddCampaignTemplate",
        element: <AddCampaignTemplate />,
        state: "emailsystem.AddCampaignTemplate",
      },
      {
        path: "/communication/EditCampaignTemplate",
        element: <EditCampaignTemplate />,
        state: "emailsystem.EditCampaignTemplate",

      },


    ],
  },



  {
    path: "/emailsystem",
    element: <DashboardPageLayout />,
    state: "emailsystem",
    sidebarProps: {
      displayText: "emailsystem",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        path: "/emailsystem/group",
        element: <Groupmaster />,
        state: "emailsystem.group",
        sidebarProps: {
          displayText: "Group master",
        },
      },
      {
        path: "/emailsystem/Creategroupmaster",
        element: <Creategroupmaster />,
        state: "emailsystem.Creategroupmaster",
      },
      {
        path: "/emailsystem/Editgroupmaster",
        element: <Editgroupmaster />,
        state: "emailsystem.Editgroupmaster",
      },

      {
        path: "/emailsystem/emailsettings",
        element: <Emailsettingmaster />,
        state: "emailsystem.emailMaster",
      },
      {
        path: "/emailsystem/emailcampaign",
        element: <EmailcampgianMaster />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/addcampagianmaster",
        element: <CreatemailcampgiontForm />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/editcampagianmaster",
        element: <Editcampgianmailmaster />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/emaileventsettings",
        element: <EmaileventMaster />,
        state: "emailsystem.emaileventsettings",
      },
      {
        path: "/emailsystem/addeventmaster",
        element: <CreatemaileventForm />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/editeventnmaster",
        element: <Editeventemail />,
        state: "email.emailMaster",
      },

      {
        path: "/emailsystem/emailtamplate",
        element: <CampaignTemplate />,
        state: "emailsystem.emailtamplate",
        sidebarProps: {
          displayText: "CampaignTemplate",
        },
      },
      {
        path: "/emailsystem/AddCampaignTemplate",
        element: <AddCampaignTemplate />,
        state: "emailsystem.AddCampaignTemplate",
      },
      {
        path: "/emailsystem/EditCampaignTemplate",
        element: <EditCampaignTemplate />,
        state: "emailsystem.EditCampaignTemplate",
      },
    ],
  },







  {
    path: "/reports",
    element: <DashboardPageLayout />,
    state: "reports",
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "reports.index",
      },


      {
        path: "/reports/fuelconspwithopening",
        element: <FuelConspWithOpening />,
        state: "reports.fuelconspwithopening",
      },



      {
        path: "/reports/fuelconspwithoutopening",
        element: <FuelConspWithoughtOpening />,
        state: "reports.fuelconspwithoutopening",
      },


      {
        path: "/reports/fuelconsumption",
        element: <FuelConsumption />,
        state: "reports.fuelconsumption",
      },



      {
        path: "/reports/probablewiretempering",
        element: <ProbableWireTempering />,
        state: "reports.probablewiretempering",
      },


      {
        path: "/reports/vehicledetailsummary",
        element: <VehiclesDetailsSummery />,
        state: "reports.vehicledetailsummary",
      },


      {
        path: "/reports/vehiclesnotmoved",
        element: <VehiclesNotMoved />,
        state: "reports.vehiclesnotmoved",
      },


      {
        path: "/reports/vehicletrack",
        element: <VehicleTrack />,
        state: "reports.vehicletrack",
      },








    ],
  },








  {
    path: "/employeeinfo",
    element: <DashboardPageLayout />,
    state: "employeeinfo",
    sidebarProps: {
      displayText: "Employee",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "employeeinfo.index",
      },
      {
        path: "/employeeinfo/employee",
        element: <Empmaster />,
        state: "employeeinfo.employee",
        sidebarProps: {
          displayText: "Employee Master",
        }
      },
      {
        path: "/employeeinfo/creatempmaster",
        element: <EmployeeAdd />,
        state: "employeeinfo.creatempmaster",
      },
      {
        path: "/employeeinfo/editempmaster",
        element: <Editempform />,
        state: "employeeinfo.editempmaster",
      },

      {
        path: "/employeeinfo/department",
        element: <DepartmentMaster />,
        state: "employeeinfo.department",
      },


      {
        path: "/employeeinfo/designation",
        element: <DesignationMaster />,
        state: "employeeinfo.designation",
      },


      {
        path: "/employeeinfo/organization",
        element: <Institute />,
        state: "employeeinfo.organization",
        sidebarProps: {
          displayText: "Organization",
        }
      },
      {
        path: "/employeeinfo/organizationAdd",
        element: <InstituteAdd />,
        state: "employeeinfo.organizationAdd",
      },
      {
        path: "/employeeinfo/organizationEdit",
        element: <InstituteEdit />,
        state: "employeeinfo.organizationEdit",
      },






    ],
  },


  {
    path: "/Help",
    element: <DashboardPageLayout />,
    state: "Help",
    child: [
      {
        path: "/Help/HelpCreation",
        element: <HelpCreation />,
        state: "Help.HelpCreation",
        sidebarProps: {
          displayText: "Help Creation",
        },
      },

      {
        path: "/Help/HelpDesk",
        element: <HelpDesk />,
        state: "Help.HelpDesk",
        sidebarProps: {
          displayText: "Help Desk",
        },
      },
    ],
  },



  //====================================vehicleMaster-start================================//


  {
    path: "/vehiclemanagement",
    element: <DashboardPageLayout />,
    state: "vehiclemanagement",
    sidebarProps: {
      displayText: "Vehicle Master",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        path: "/vehiclemanagement/vehiclemaster",
        element: <DashboardPageLayout />,
        state: "vehiclemaster",
        sidebarProps: {
          displayText: "Vehicle Master",
          icon: <DashboardOutlinedIcon />,
        },
        child: [
          {
            index: true,
            element: <DashboardIndex />,
            state: "vehiclemaster.index",
          },

        ],
      },
      {
        path: "/vehiclemanagement/brandmaster",
        element: <BrandMaster />,
        state: "vehiclemaster.brandmaster",
        sidebarProps: {
          displayText: "Brand Master",
        },
      },


      {
        path: "/vehiclemanagement/fuelbalcorrection",
        element: <FuelBalCorrection />,
        state: "vehiclemaster.fuelbalcorrection",
        sidebarProps: {
          displayText: "Fuel Bal Correction",
        },
      },

      {
        path: "/vehiclemanagement/fueltype",
        element: <FuelType />,
        state: "vehiclemaster.fueltype",
        sidebarProps: {
          displayText: "Fuel Type",
        },
      },



      {
        path: "/vehiclemanagement/vehicleauditinformation",
        element: <VehicleAudit />,
        state: "vehiclemaster.vehicleauditinformation",
        sidebarProps: {
          displayText: "Vehicle Audit",
        },
      },


      {
        path: "/vehiclemanagement/trackingdata",
        element: <TrackingReportData />,
        state: "vehiclemaster.trackingdata",

      },


      {
        path: "/vehiclemanagement/vehicledetail",
        element: <VehicleDetail />,
        state: "vehiclemaster.vehicledetail",
        sidebarProps: {
          displayText: "Vehicle Details",
        },
      },


      {
        path: "/vehiclemanagement/vehicletype",
        element: <VehicleType />,
        state: "vehiclemaster.vehicletype",
        sidebarProps: {
          displayText: "Vehicle Type",
        },
      },


      {
        path: "/vehiclemanagement/vehicletypeinfo",
        element: <VehicleTypeInfo />,
        state: "vehiclemaster.vehicletypeinfo",
        sidebarProps: {
          displayText: "Vehicle Type Info",
        },
      },







      {
        path: "/vehiclemanagement/vehiclecomplaints",
        element: <DashboardPageLayout />,
        state: "vehiclecomplaint",
        sidebarProps: {
          displayText: "Vehicle Complaint",
          icon: <DashboardOutlinedIcon />,
        },
        child: [
          {
            index: true,
            element: <DashboardIndex />,
            state: "vehiclecomplaint.index",
          },

        ],
      },
    ]
  },


  //=====================================Vehicle Complaint=====================================//



  {
    path: "/vendorinfo",
    element: <DashboardPageLayout />,
    state: "vendorinfo",
    sidebarProps: {
      displayText: "Vendor Info",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "vendorinfo.index",
      },


    ],
  },
  {
    path: "/Admin",
    element: <DashboardPageLayout />,
    state: "Admin",
    sidebarProps: {
      displayText: "Admin",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "Admin.index",
      },
      {
        path: "/Admin/menucreate",
        element: <MenuMaster />,
        state: "Admin.menucreate",
        sidebarProps: {
          displayText: "Menu Master",
        },
      },


      {
        path: "/Admin/MenuMasterAdd",
        element: <MenuMasterAdd />,
        state: "masters.MenuMasterAdd",
      },

      {
        path: "/Admin/MenuMasterEdit",
        element: <MenuMasterEdit />,
        state: "masters.MenuMasterEdit",
      },





      {
        path: "/Admin/masters",
        element: <DashboardPageLayout />,
        state: "masters",
        sidebarProps: {
          displayText: "Master",
          icon: <DashboardOutlinedIcon />,
        },
        child: [
          {
            index: true,
            element: <DashboardIndex />,
            state: "master.index",
          },

          {
            path: "/Admin/masters/zone",
            element: <ZoneMaster />,
            state: "masters.ZoneMaster",
            sidebarProps: {
              displayText: "Zone zone",
            },
          },

          {
            path: "/Admin/masters/city",
            element: <CityMaster />,
            state: "masters.CityMaster",
            sidebarProps: {
              displayText: "District",
            },
          },
          {
            path: "/Admin/masters/State",
            element: <StateMaster />,
            state: "masters.StateMaster",
            sidebarProps: {
              displayText: "State",
            },
          },

          {
            path: "/Admin/masters/Country",
            element: <CountryMaster />,
            state: "masters.CountryMaster",
            sidebarProps: {
              displayText: "Country",
            },
          },


          {
            path: "/Admin/masters/category",
            element: <Itemcategory />,
            state: "masters.category",
          },

          {
            path: "/Admin/masters/stockbin",
            element: <BinKudaghar />,
            state: "masters.stockbin",
            sidebarProps: {
              displayText: "Stock Bin",
            },
          },


          {
            path: "/Admin/masters/BinKudagharAdd",
            element: <BinKudagharAdd />,
            state: "masters.BinKudagharAdd",

          },



          {
            path: "/Admin/masters/BinKudagharEdit",
            element: <BinKudagharEdit />,
            state: "masters.BinKudagharEdit",

          },



          {
            path: "/Admin/masters/Tax",
            element: <Taxmaster />,
            state: "masters.Taxmaster",
            sidebarProps: {
              displayText: "Tax master",
            },
          },
          {
            path: "/Admin/masters/Unit",
            element: <Unitmaster />,
            state: "masters.Unitmaster",
            sidebarProps: {
              displayText: "Unit master",
            },
          },

          {
            path: "/Admin/masters/VehicleDetail",
            element: <VehicleDetail />,
            state: "masters.VehicleDetail",
            sidebarProps: {
              displayText: "Vehicle Detail",
            },
          },


          {
            path: "/Admin/masters/VehicleDetailAdd",
            element: <VehicleDetailAdd />,
            state: "masters.VehicleDetailAdd",

          },

          {
            path: "/Admin/masters/VehicleDetailEdit",
            element: <VehicleDetailEdit />,
            state: "masters.VehicleDetailEdit",

          },




          {
            path: "/Admin/masters/BrandMaster",
            element: <BrandMaster />,
            state: "masters.BrandMaster",
            sidebarProps: {
              displayText: "Brand Master",
            },
          },


          {
            path: "/Admin/masters/BrandMasterAdd",
            element: <BrandMasterAdd />,
            state: "masters.BrandMasterAdd",

          },

          {
            path: "/Admin/masters/BrandMasterEdit",
            element: <BrandMasterEdit />,
            state: "masters.BrandMasterEdit",

          },


          {
            path: "/Admin/masters/menumaster",
            element: <MenuMaster />,
            state: "masters.menucreate",

          },






          {
            path: "/Admin/masters/FuelType",
            element: <FuelType />,
            state: "masters.FuelType",
            sidebarProps: {
              displayText: "Fuel Type",
            },
          },


          {
            path: "/Admin/masters/FuelTypeAdd",
            element: <FuelTypeAdd />,
            state: "masters.FuelTypeAdd",

          },

          {
            path: "/Admin/masters/FuelTypeEdit",
            element: <FuelTypeEdit />,
            state: "masters.FuelTypeEdit",

          },




          {
            path: "/Admin/masters/VehicleType",
            element: <VehicleType />,
            state: "masters.VehicleType",
            sidebarProps: {
              displayText: "Vehicle Type",
            },
          },


          {
            path: "/Admin/masters/VehicleTypeAdd",
            element: <VehicleTypeAdd />,
            state: "masters.VehicleTypeAdd",

          },

          {
            path: "/Admin/masters/VehicleTypeEdit",
            element: <VehicleTypeEdit />,
            state: "masters.VehicleTypeEdit",

          },


          {
            path: "/Admin/masters/ward",
            element: <AreaWardMaster />,
            state: "masters.ward",

          },




          {
            path: "/Admin/masters/VehicleAudit",
            element: <VehicleAudit />,
            state: "masters.VehicleAudit",
            sidebarProps: {
              displayText: "Vehicle Audit",
            },
          },


          {
            path: "/Admin/masters/VehicleAuditAdd",
            element: <VehicleAuditAdd />,
            state: "masters.VehicleAuditAdd",

          },

          {
            path: "/Admin/masters/VehicleAuditEdit",
            element: <VehicleAuditEdit />,
            state: "masters.VehicleAuditEdit",

          },




          {
            path: "/Admin/masters/VehicleTypeInfo",
            element: <VehicleTypeInfo />,
            state: "masters.VehicleTypeInfo",
            sidebarProps: {
              displayText: "Vehicle Type Info",
            },
          },


          {
            path: "/Admin/masters/VehicleTypeInfoAdd",
            element: <VehicleTypeInfoAdd />,
            state: "masters.VehicleTypeInfoAdd",

          },

          {
            path: "/Admin/masters/VehicleTypeInfoEdit",
            element: <VehicleTypeInfoEdit />,
            state: "masters.VehicleTypeInfoEdit",

          },





          {
            path: "/Admin/masters/FuelBalCorrection",
            element: <FuelBalCorrection />,
            state: "masters.FuelBalCorrection",

          },

          {
            path: "/Admin/masters/area/ward",
            element: <AreaWardMaster />,
            state: "masters.AreaWardMaster",

          },

        ],

      },
      {
        path: "/Admin/security",
        element: <DashboardPageLayout />,
        state: "security",
        sidebarProps: {
          displayText: "Security",
          icon: <DashboardOutlinedIcon />,
        },
        child: [
          {
            index: true,
            element: <DashboardIndex />,
            state: "security.index",
          },

          {
            path: "/Admin/security/Roles",
            element: <RoleMaster />,
            state: "security.RoleMaster",
            sidebarProps: {
              displayText: "Role Master",
            }
          },

          {
            path: "/Admin/security/juridictionwisefilestore",
            element: <Jurisdiction />,
            state: "security.juridictionwisefilestore",
            sidebarProps: {
              displayText: "Jurisdiction",
            }
          },

        ],
      },
      {
        path: "/Admin/security/userpremission",
        element: <UserPermissionMaster />,
        state: "UserManagement.UserPermissionMaster",
        sidebarProps: {
          displayText: "User Permission",
        }
      },



    ]
  },

  {
    element: <PageNotFound />,
    state: "pageNotFound",
    path: "*",
    sidebarProps: {
      displayText: "Page Not Found",
    },
  },

];



export default appRoutes;

